import React from 'react';
import styled from 'styled-components';
import { RichText } from 'prismic-reactjs';

const Container = styled.div`
  text-align: center;
  margin: 0 0 60px 50px;
  width: calc(20% - 40px);
  @media (min-width: 1024px) {
    &:nth-child(5n + 1) {
      margin-left: 0;
    }
  }
  @media (max-width: 1024px) and (min-width: 540px) {
    width: calc(33% - 40px);
    &:nth-child(3n + 1) {
      margin-left: 0;
    }
  }
  @media (max-width: 540px) {
    width: calc(50% - 20px);
    margin-left: 20px;
    &:nth-child(2n + 1) {
      margin-left: 0;
    }
  }
  &:first-child {
    margin-left: 0;
  }
  img {
    width: 100%;
  }
  strong {
    font: bold italic 20px 'Times new roman';
    display: block;
    margin: 16px 0;
  }
`

const Unit = ({imagem, texto}) => {
  return (
    <Container>
      <img alt={ texto[0].text } src={ imagem.url } />
      { RichText.render(texto) }
    </Container>
  )
}

export default Unit;
